import React from "react";
import { connect } from "react-redux";
import { bindActionCreators } from "redux";

import {
  getInsightfulContent,
  sendToFriendReportOnEmail,
} from "../dashboard/actions";
import { createContentMap, getContentLatestVersion } from "../signup/actions";
import { getAssessmentResultByAssessmentAttemptId } from "../plan/actions";
import { GetUserById } from "../settings/actions";
import EnneagramReport from "./component";
import CareerPreferenceReport from "./component";

const mapStateToProps = ({ funnelStep }) => ({ funnelStep });

const mapDispatchToProps = (dispatch) =>
  bindActionCreators(
    {
      getInsightfulContentConnect: getInsightfulContent,
      getAssessmentResultByAssessmentAttemptIdConnect:
        getAssessmentResultByAssessmentAttemptId,
      getUserByIdConnect: GetUserById,
      sendToFriendReportOnEmailConnect: sendToFriendReportOnEmail,
    },
    dispatch
  );

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(CareerPreferenceReport);
